import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { HttpClientModule } from '@angular/common/http';
import { AuthRoutingModule, routedComponents } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatSliderModule } from '@angular/material/slider';
import { DefaultModule } from '../layouts/default/default.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridModule, PageService, SortService, FilterService, GroupService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { LoginComponent } from './login.component';
import { FaqPublicViewComponent } from './faqPublicView.component';
import { EmpadronamientoComponent } from './empadronamiento.component';
import { ExpensaPublicComponent } from './expensaPublic.component';

const components = [
    AuthComponent,
  ];
  
  @NgModule({
    imports: [
      AuthRoutingModule,
      HttpClientModule,
      FormsModule,
      CommonModule,
      MatCardModule,
      FlexLayoutModule,
      MatSelectModule,
      MatButtonModule,
      MatSliderModule,
      DefaultModule,
      GridModule,
      MatCheckboxModule,
      MatGridListModule,
      MatInputModule,
      MatIconModule,
      MatFormFieldModule,
      MatExpansionModule,
      ReactiveFormsModule
      //BrowserAnimationsModule,
    ],
    providers: [
      PageService, 
      SortService, 
      FilterService, 
      GroupService, 
      ResizeService
    ],
    declarations: [
      ...routedComponents,
    ],
    exports: [
      LoginComponent,
      FaqPublicViewComponent,
      EmpadronamientoComponent,
      ExpensaPublicComponent
    ],
  })
export class AuthModule { }